import { Box, Container, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

const UnAuthorizedPage: FunctionComponent = () => {
    return (
        <Box
            component='main'
            sx={{
                alignItems: 'center',
                display: 'flex',
                flexGrow: 1,
                minHeight: '100%',
            }}
        >
            <Container maxWidth='md'>
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        sx={{
                            mb: 3,
                            textAlign: 'center',
                        }}
                    >
                        <img
                            alt='Under development'
                            src='/src/assets/errors/error-401.png'
                            style={{
                                display: 'inline-block',
                                maxWidth: '100%',
                                width: 400,
                            }}
                        />
                    </Box>
                    <Typography
                        align='center'
                        sx={{ mb: 3 }}
                        variant='h3'
                        color='error'
                    >
                        401: Kein Zugriff auf diese Seite
                    </Typography>
                    <Typography
                        align='center'
                        color='text.secondary'
                        variant='body1'
                    >
                        Für diese Seite fehlt die Berechtigung. Bitte den
                        Administrator kontaktieren.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default UnAuthorizedPage;
